import axios from 'axios';
import cfac22 from '../../cfac22';

export const identify = async (...args) => {
  const params =
    args.length === 1 && args[0] && typeof args[0] === 'object' && !Array.isArray(args[0])
      ? args[0]
      : Object.fromEntries(['identifier', 'partnerId'].map((key, index) => [key, args[index]]));

  const { identifier, partnerId } = params;

  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/identify`;

    const { data } = await axios.post(
      endpoint,
      { identifier, partnerId },
      {
        withCredentials: true,
        headers: {
          'Full-Url': window.location.href,
        },
      }
    );

    const hasLegacyEnvelope = Object.prototype.hasOwnProperty.call(data, 'success');

    if (!hasLegacyEnvelope) {
      return {
        success: true,
        data,
      };
    }

    const { success, result, error } = data;

    if (!success) {
      return {
        success: false,
        error: error || 'Erro ao identificar usuario',
      };
    }

    return {
      success: true,
      data: result,
    };
  } catch (error) {
    console.error('IDENTIFY API - Error:', error);
    throw error?.response?.data || error;
  }
};
